import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TransferDetails } from "../../template/TransactionTable";

interface SetPaymentReceiptModalOpenPayload {
  open: boolean;
  receiptObj: TransferDetails | null;
  modalType: string | null;
}

export interface AccountsModalState {
  firstModalOpen: boolean;
  secondModalOpen: boolean;
  paymentReceiptModalOpen: boolean;
  paymentReceiptObj: TransferDetails | null;
  modalType: string | null;
}

export const initialState: AccountsModalState = {
  firstModalOpen: false,
  secondModalOpen: false,
  paymentReceiptModalOpen: false,
  paymentReceiptObj: null,
  modalType: null,
};

export const accountsModalSlice = createSlice({
  name: "accountsModal",
  initialState,
  reducers: {
    setFirstModalOpen: (state, action: PayloadAction<boolean>) => {
      state.firstModalOpen = action.payload;
    },
    setSecondModalOpen: (state, action: PayloadAction<boolean>) => {
      state.secondModalOpen = action.payload;
    },
    setPaymentReceiptModalOpen: (
      state,
      action: PayloadAction<SetPaymentReceiptModalOpenPayload>
    ) => {
      state.paymentReceiptModalOpen = action.payload.open;
      state.paymentReceiptObj = action.payload.receiptObj;
      state.modalType = action.payload.modalType;
    },
  },
});

export const {
  setFirstModalOpen,
  setSecondModalOpen,
  setPaymentReceiptModalOpen,
} = accountsModalSlice.actions;

export default accountsModalSlice.reducer;
